//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
import { PojoSet } from 'pojo-sets';

import { FullScreenWorkflowAction } from '@galleries/actions/fullScreenWorkflowActions';
import {
  FULLSCREEN_WORKFLOW_ACTIONS,
  IFullScreenWorkflowState,
} from '@galleries/models/fullScreenWorkflowModel';

export const initialState: IFullScreenWorkflowState = {
  inWorkflow: {},
  flags: {},
  conditionalFinalToasts: [],
};

export default function FullScreenWorkflowReducer(
  state: IFullScreenWorkflowState = initialState,
  action: FullScreenWorkflowAction,
): IFullScreenWorkflowState {
  switch (action.type) {
    case FULLSCREEN_WORKFLOW_ACTIONS.START_WORKFLOW:
      return {
        ...state,
        inWorkflow: PojoSet.add(state.inWorkflow, action.workflowName),
      };

    case FULLSCREEN_WORKFLOW_ACTIONS.STOP_WORKFLOW:
      return {
        ...state,
        inWorkflow: PojoSet.remove(state.inWorkflow, action.workflowName),
      };

    case FULLSCREEN_WORKFLOW_ACTIONS.ADD_CONDITIONAL_FINAL_TOAST:
      return {
        ...state,
        conditionalFinalToasts: [
          ...state.conditionalFinalToasts,
          {
            toast: action.toast,
            requiredFlags: action.requiredFlags,
          },
        ],
      };

    case FULLSCREEN_WORKFLOW_ACTIONS.SET_FLAG:
      return {
        ...state,
        flags: PojoSet.toggle(state.flags, action.flag, action.val),
      };

    case FULLSCREEN_WORKFLOW_ACTIONS.RESET_STATE:
      return initialState;

    default:
      return state;
  }
}
